import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=c4589b42&scoped=true"
import script from "./Control.vue?vue&type=script&lang=js"
export * from "./Control.vue?vue&type=script&lang=js"
import style0 from "./Control.vue?vue&type=style&index=0&id=c4589b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4589b42",
  null
  
)

export default component.exports